export default __webpack_public_path__ + "static/media/left.699a89c2.svg";